export const GITHUB_REPO_ANNOTATION = 'github.com/project-slug';
